import React, { FC } from 'react'
import {
    Drawer,
    Button,
    Space,
    Divider,
    Descriptions,
    Image
} from 'antd'
import ImageError from '~utils/ImageError'
import { useSelector } from 'react-redux'
import { ApplicationState } from '~store/index'

interface ViewProps {
    close: () => void
    swapDataEdit: () => void
    isOpen: boolean
    data: any
}

const ViewGames: FC<ViewProps> = ({ close, isOpen, data, swapDataEdit }) => {

    const title = "View Game"

    const authState = useSelector((state: ApplicationState) => state.auth)
    const permissions = authState.data.permissions

    return (
        <>
            <Drawer
                title={title}
                onClose={close}
                open={isOpen}
                bodyStyle={{ paddingBottom: 80 }}
                width={global.window.innerWidth <= 1200 ? global.window.innerWidth : global.window.innerWidth * .4}
                extra={
                    <Space>
                        {permissions && permissions["GAMES-MANAGEMENT"] === "EDIT" && (
                            <Button
                                type="primary"
                                className="btn btn-warning btn-sm text-white me-2"
                                onClick={swapDataEdit}
                            >
                                <i className="fa-solid fa-edit me-1"></i>
                                Edit</Button>
                        )}
                    </Space>
                }>
                <Descriptions title={"Game Information"} column={1} labelStyle={{ justifyContent: 'flex-end', minWidth: 100 }}>
                    <Descriptions.Item label="Game Name">{data.gameName}</Descriptions.Item>
                    <Descriptions.Item label="Game Code">{data.gameCode}</Descriptions.Item>
                    <Descriptions.Item label="Type">{data.type}</Descriptions.Item>
                    <Descriptions.Item label="Provider">{data.providerName}</Descriptions.Item>
                    <Descriptions.Item label="Image">
                        <Image
                            className='ant-img-circle'
                            width={220}
                            height={220}
                            alt={data.gameName}
                            src={data.imageURL ? data.imageURL : 'error'}
                            fallback={ImageError}
                        />
                    </Descriptions.Item>
                </Descriptions>
                {data.lobby !== null && data.lobby.length > 0 && (
                    <>
                        <Divider />
                        <Descriptions title="Lobby" column={1} labelStyle={{ justifyContent: 'flex-end', minWidth: 100 }}>
                            {data.lobby.map((item: any, index: number) => (
                                <Descriptions.Item key={index} label={index + 1}>{item}</Descriptions.Item>
                            ))}
                        </Descriptions>
                    </>
                )}
                <Divider />
                <Descriptions title="System Information" column={1} labelStyle={{ justifyContent: 'flex-end', minWidth: 100 }}>
                    <Descriptions.Item label="Display">
                        {data.display
                            ? <div className="msn-badge badge-success ms-2">Open</div>
                            : <div className="msn-badge badge-danger ms-2">Close</div>}
                    </Descriptions.Item>
                    <Descriptions.Item label="Maintenance">
                        {data.active
                            ? <div className="msn-badge badge-success ms-2">Yes</div>
                            : <div className="msn-badge badge-danger ms-2">No</div>}
                    </Descriptions.Item>
                </Descriptions>
            </Drawer>
        </>
    )
}
export default ViewGames

